import {AnimatedNumber} from '@lazy'
import {TldrawApp, useTldrawApp} from '@modules/whiteboard'
import {action, autorun, classNames, IDisposer, observable, React, useLocalStore} from '@api'
import {observer, Popover2} from '@api'
import {Button} from '@blueprintjs/core'
import {PrimaryIconButton} from 'centric-ui-components'
import * as css from './ZoomMenu2.css'
import {Tooltip} from '@material-ui/core'

/// region Store

export class ZoomMenu2Store {
  constructor(public app : TldrawApp) {

  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = [
      autorun(() => {
        const {previousZoomAmount, camera} = this

        if (previousZoomAmount && camera.zoom != 100) {
          this.previousZoomAmount = null
        }
      })
    ]

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  get camera() { return this.app.camera}

  @action onMouseEnter = () => {
    this.app.appState.showZoomExpandedMenu = true
  }

  @observable previousZoomAmount
  @action onClickZoomNumber = async () => {
    const {app: {camera}} = this
    if (camera.animating) return

    if (this.previousZoomAmount) {
      await camera.animatedZoomTo(this.previousZoomAmount)
      this.previousZoomAmount = null
    }
    else {
      this.previousZoomAmount = camera.zoom
      await camera.animatedZoomTo(1)
    }
  }
}

export const ZoomMenu2StoreContext = React.createContext<ZoomMenu2Store>(null)
export const useZoomMenu2Store = () => React.useContext(ZoomMenu2StoreContext)

/// endregion

/// region Components

export const ZoomMenu2 = observer<{className?: string}>(function ZoomMenu2({className}) {
  const app = useTldrawApp(),
    {onMouseEnter, onClickZoomNumber, previousZoomAmount, app: {appState: {showZoomExpandedMenu}, camera: {zoom, zoomOut, zoomIn, zoomToFit, zoomToContent, zoomToSelection}}} = useLocalStore(() => new ZoomMenu2Store(app))

  return (
    <div className={classNames(css.root, className)} data-expanded={showZoomExpandedMenu} onMouseEnter={onMouseEnter}>
      <div className={css.expandedArea}>
        <PrimaryIconButton tooltip='Fit to Selection' tooltipPosition='top' icon='select' onClick={zoomToSelection}/>
        <PrimaryIconButton tooltip='Fit to Content' tooltipPosition='top' icon='console' onClick={zoomToContent}/>
        <PrimaryIconButton tooltip='Fit to Screen' tooltipPosition='top' icon='zoom-to-fit' onClick={zoomToFit}/>
      </div>
      <div className={css.alwaysVisible}>
        <PrimaryIconButton tooltip='Zoom Out' tooltipPosition='top' icon='minus' onClick={zoomOut} />
        <Tooltip placement='top' title={`Zoom to ${previousZoomAmount ? (previousZoomAmount * 100).toFixed(0) : '100'}%`}>
          <Button className={css.button} minimal onClick={onClickZoomNumber}>
            <AnimatedNumber  duration={150} delay={0} formatValue={v => `${v.toFixed(0)}%`}
                            value={Math.round(zoom * 100)} />
        </Button>

        </Tooltip>
        <PrimaryIconButton tooltip='Zoom In' tooltipPosition='top' icon='plus' onClick={zoomIn}/>
      </div>
    </div>
    // <Popover2
    //   interactionKind='click'
    //   position='bottom'
    //   content={
    //     <Menu>
    //       <WhiteboardMenuItem shouldDismissPopover={false} text={'Zoom In'} kbd='#+' onClick={zoomIn}/>
    //       <WhiteboardMenuItem shouldDismissPopover={false} text={'Zoom Out'} kbd='#−' onClick={zoomOut}/>
    //       <WhiteboardMenuItem shouldDismissPopover={false} text={'To 100%'} kbd='⇧0' onClick={resetZoom}/>
    //       <WhiteboardMenuItem shouldDismissPopover={false} text={'To Fit'} kbd='⇧1' onClick={zoomToFit}/>
    //       <WhiteboardMenuItem shouldDismissPopover={false} text={'To Selection'} kbd='⇧2' onClick={zoomToSelection}/>
    //     </Menu>
    //   }
    // >
    //   <Tooltip title='Zoom Level' placement='bottom'>
    //     <Button className={css.button} minimal onDoubleClick={resetZoom}>
    //       {Math.round(zoom * 100)}%
    //     </Button>
    //   </Tooltip>
    // </Popover2>
  )
})

///endregion


// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/TopPanel/ZoomMenu/ZoomMenu2.tsx